/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Preview_Col_AiInputs */

const da_forside_preview_col_ai = /** @type {(inputs: Forside_Preview_Col_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI`)
};

/** @type {(inputs: Forside_Preview_Col_AiInputs) => LocalizedString} */
const en_forside_preview_col_ai = da_forside_preview_col_ai;

/**

* @param {Forside_Preview_Col_AiInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_preview_col_ai = /** @type {((inputs?: Forside_Preview_Col_AiInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Preview_Col_AiInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_preview_col_ai(inputs)
	return /** @type {LocalizedString} */ ("AI")
});